<template>
  <el-dialog
    custom-class="sharingModal"
    append-to-body
    :visible.sync="visible"
    :before-close="close"
  >
    <h2>Sharing to MangoMolo</h2>

    <div class="sharing-metadata">
      <p class="text">English title</p>
      <el-input v-model="textTitle" placeholder="Please add english title" />
      <p class="text">Arabic title</p>
      <el-input 
      v-model="textTitleArabic" placeholder="Please add arabic title" />
      <!-- <p class="text">Description</p>
      <el-input
        v-model="textDescription"
        placeholder="Please add descriptions"
      /> -->
      <!-- <p class="text">Category</p>
      <el-cascader
        :options="getInfoCategory"
        placeholder="Category"
        :props="{ children: 'sub_categories', label: 'title', value: 'id' }"
        @change="handleChange"
      ></el-cascader> -->
      <p class="textPosition">Change channel</p>
      <el-dropdown class="dropDownBackground" @command="handleCommand">
        <span class="el-dropdown-link">
          <div class="itemChannelCategory">{{ titleChangeStream }}</div>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in MMChannelsCategoty"
            :key="item.id"
            :command="item"
            >{{ item.title }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <p class="textPosition">Category</p>
      <el-cascader
        ref="getTitle"
        v-model="valueCasc"
        :options="getInfoCategory"
        :disabled="disabledbutton"
        placeholder="Category"
        :props="{ children: 'sub_categories', label: 'title', value: 'id' }"
        @change="handleChange"
      ></el-cascader>
      <div v-if="titleCascade">
        <div v-for="item in titleCascade" :key="item" class="colorCategoryText">
          {{ item }}
        </div>
      </div>
    </div>

    <div class="share-buttons">
      <el-button @click="tryShareMMVideo">
        Share
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { shareVideo } from "@/api/socials/sharings.js";
import { getAPI, token } from "@/api/params.js";
import { filterArrayByIds } from "@/utils/parsing.js";
import { getChannelsWhithCategory, getCategoryMM } from "@/api/edit.js";
import {
  getChannelsWhithCategoryRadio,
  getCategoryMMRadio
} from "../../../api/editAudio.js";

import { mapMutations, mapState, mapGetters } from "vuex";

// @group Socials
// Dialog window for video sharing to different socials
export default {
  name: "SharingFromMangomolo",
  components: {},
  props: {
    // Form open flag
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    multistepId: {
      type: Number,
      default: null
    },
    descriptionInfo: {
      type: String,
      default: ""
    },
    categoryVideo: {
      type: Number,
      default: 0
    },
    channels: {
      type: Array
    }
  },
  data() {
    return {
      scheduledTime: null,
      disabledBtnShare: false,
      textTitle: this.title,
      textTitleArabic: this.title,
      textDescription: this.descriptionInfo,
      categoryVideoinfo: this.categoryVideo,
      getInfoCategory: null,
      category: null,
      titleChangeStream: "Change stream",
      valueChangeStream: "Change stream",
      MMChannelsCategoty: null,
      show: "",
      seria: "",
      season: "",
      valueCasc: null,
      disabledbutton: true,
      titleCascade: []
    };
  },
  async created() {
    //Get channels whith category
    if (this.channelType === "audio") {
      const chaneslList = await getChannelsWhithCategoryRadio();
      this.MMChannelsCategoty = chaneslList;
    } else {
      const chaneslList = await getChannelsWhithCategory();
      this.MMChannelsCategoty = chaneslList;
    }

    //Get categories by api
    // const response = await fetch(
    //   `${getAPI()}/mangomolo/categories_tree?token=${token}`
    // );
    // if (response.ok) {
    //   const resp = await response.json();
    //   this.getInfoCategory = resp.data;
    // }
  },
  methods: {
    ...mapMutations(["setSharingChannel"]),
    async handleCommand(changeStream) {
      let categoryChannelMM = [];
      if (this.channelType === "audio") {
        categoryChannelMM = await getCategoryMMRadio(changeStream.id);
      } else {
        categoryChannelMM = await getCategoryMM(changeStream.id);
      }
      this.titleChangeStream = changeStream.title;
      this.setSharingChannel(changeStream.id)
      this.getInfoCategory = categoryChannelMM;
      const displayNameStream = this.channels.filter(
        e => e.channel_id == changeStream.id
      )[0].display_name;
      this.valueChangeStream = displayNameStream;
      this.$emit("valueChangeStream", this.valueChangeStream);
    },
    handleChange(idCategories) {
      this.$refs.getTitle.toggleDropDownVisible(false);
      const titleCascad = this.$refs.getTitle.getCheckedNodes();
      this.titleCascade = titleCascad[0].pathLabels;
      if (this.titleCascade[1] != "") {
        this.show = this.titleCascade[1];
      }
      if (this.titleCascade[2] != "") {
        this.season = this.titleCascade[2];
      }
      const filterArr = idCategories[idCategories.length - 1];
      this.category = Number(filterArr);
    },
    // handleChange(idCategories) {
    //   const filterArr = idCategories[idCategories.length - 1];
    //   this.category = Number(filterArr);
    // },
    close() {
      this.$emit("closed");
    },
    tryShareMMVideo() {
      this.$emit(
        "sharingToMM",
        this.textTitle,
        this.textTitleArabic,
        this.textDescription,
        this.category
      ),
        this.$emit("closed");
    }
  },
  computed: {
    ...mapState({
      youtubeAccounts: state => state.socials.youtube.accounts,
      facebookAccounts: state => state.socials.facebook.accounts,
      instagramAccounts: state => state.socials.instagram.accounts,
      twitterAccounts: state => state.socials.twitter.accounts,
      facebookGroupsInited: state => state.socials.facebook.groupsInited,
      facebookPagesInited: state => state.socials.facebook.pagesInited,
      instagramInited: state => state.socials.instagram.inited,
      timezone: state => state.timezone.timezone
    }),
    ...mapGetters(["channelType"]),
    ...mapGetters("socials", {
      getYoutubeAcc: "getYoutubeAccountById",
      getFacebookAcc: "getFacebookAccountById",
      getInstagramAcc: "getInstagramAccountById",
      getTwitterAcc: "getTwitterAccountById"
    })
  },
  watch: {
    getInfoCategory() {
      if (this.getInfoCategory !== []) {
        this.disabledbutton = false;
      }
    }
  }
};
</script>
<style>
.el-dropdown-menu.el-popper::-webkit-scrollbar {
  display: none !important;
}

.el-scrollbar ::-webkit-scrollbar {
  display: none !important;
}
.el-cascader-menu__list {
  width: 185px;
  height: auto;
  min-height: 60px;
}
</style>

<style lang="scss">
.itemChannelCategory {
  width: 100%;
  font-family: "POPPINS";
}
.el-dropdown {
  width: 100%;
  background: #5d5d5d;
  text-align: left;
  height: 38px;
  border-radius: 5px;
  /* margin: 13px 0 0 0; */
}

.el-dropdown-menu.el-popper {
  height: 200px;
  overflow: scroll;
  margin-top: 1px;
}

.el-dropdown-menu.el-popper ::-webkit-scrollbar {
  display: none !important;
}

.el-dropdown-link.el-dropdown-selfdefine {
  position: relative;
  top: 11px;
  /* right: -16px; */
  display: flex;
  justify-content: space-between;
  margin: 0 11px 0px;
  height: 27px;
}

.dropDownBackground {
  background-color: #aaaaaa;
}

.el-dropdown-link-disabled {
  background: #3d3d3d;
}
.colorCategoryText {
  color: white;
  background: #aaaaaa;
  margin: 7px;
  padding: 7px;
  border-radius: 15px;
}
.text {
  text-align: left;
}
.sharingModal {
  border-radius: 5px !important;
  margin-top: 5vh !important;
  background-color: #233d4e;
}
.el-dialog__close.el-icon.el-icon-close {
  color: white;
}
.sharing-icon {
  width: 20px;
  height: 20px;
}
.sharing-link {
  width: 20px;
  height: 20px;
  padding: 3px;
}
.enqued-link {
  opacity: 0.5;
}
.converted-link img {
  cursor: pointer !important;
}
.process-link,
.success-link {
  /*animation: load-sharing 2s infinite;*/
  overflow: hidden;
  animation-duration: 1.5s;
  animation-name: load-sharing;
  animation-iteration-count: infinite;
  animation-direction: normal;
}
.error-link img {
  opacity: 0.3;
  border: 2px solid rgba(255, 0, 0, 1);
}
.sharing-metadata {
  height: 55vh;
  overflow-y: auto;
  padding: 10px;
  margin: 10px;
  border: 2px solid #5d5d5d;
  border-left: none;
  border-right: none;
}
h2.meta-title {
  margin-bottom: 20px;
}
h3.meta-block-title {
  margin-bottom: 5px;
}
.sharing-metadata-block {
  margin-bottom: 40px;
  overflow: hidden;
  /** max height was need to smooth hide/display animation, but it will broke displaying */
  /** max-height: 500px; 
  transition: max-height 0.5s ease-out, margin-bottom 0.5s ease-out; */
}
.sharing-metadata-block.hidden-metadata {
  max-height: 0px;
  margin-bottom: 0;
}
.metadata-row {
  display: flex;
}
.metadata-row-label {
  margin-right: 15px;
}
.youtube-title,
.facebook-title {
  width: 50%;
  margin-right: 10px;
}
.youtube-category,
.facebook-category {
  /*margin-left: 10px;*/
  margin-right: 10px;
  width: 30%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.margin-top {
  margin-top: 10px;
}
.youtube-privacy,
.facebook-story {
  width: 20%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.warning-block {
  margin: 15px 0;
}
.warning {
  font-style: italic;
  color: #ffa;
}

/* Sharing modal scrollbar */
/* width */
.sharingModal ::-webkit-scrollbar {
  width: 15px;
}

/* Track */
.sharingModal ::-webkit-scrollbar-track {
  background: #777;
}

/* Handle */
.sharingModal ::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 10px;
}

/* Handle on hover */
.sharingModal ::-webkit-scrollbar-thumb:hover {
  background: #444;
  border-radius: 10px;
}
@media only screen and (max-width: 767px) {
  .sharingModal {
    width: 90%;
  }
  .metadata-row {
    flex-wrap: wrap;
  }
  .el-form-item {
    min-width: 150px;
  }
  .youtube-category {
    margin: 0;
  }
}

@media only screen and (min-width: 768px) {
  .sharingModal {
    width: 70%;
  }
}

@media only screen and (min-width: 1201px) {
  .sharingModal {
    width: 50%;
  }
}

.sharingModal input {
  background-color: #aaaaaa;
  font-family: "POPPINS";
}

.el-tabs__content {
  overflow-y: auto !important;
}

.youtube-description__input .el-textarea__inner {
  font-family: "POPPINS";
}

/* Public option */
.youtube-public__button.el-checkbox-button.is-disabled:first-child
  .el-checkbox-button__inner {
  background-color: var(--dark-grey) !important;
  border: none;
}

.el-button.is-disabled,
.el-button.is-disabled:hover,
.el-button.is-disabled:focus {
  background-color: var(--dark-grey) !important;
  border: none;
}

/* Tags styles */
.el-tag.el-tag--info {
  color: white !important;
}
.tag-input {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;
  position: static;
  box-sizing: border-box;
}
.tag-input__tag {
  margin-bottom: 22px;
  margin-right: 10px;
  padding: 0 10px;
  height: 40px;
  line-height: 40px !important;
  font-size: 1em !important;
  background-color: #5d5d5d;
  color: white;
  border-radius: 5px;
}
.tag-input__tag > span {
  cursor: pointer;
}
.tag-input .el-form-item {
  width: 130px;
}
.tag-input .el-form-item__content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
}
.tag-input__text {
  padding: 10px;
  padding-left: 0;
  height: 30px;
  width: 110px;
}
.el-input.tag-input__text .el-input__suffix-inner {
  position: relative;
  top: 35px;
}
.el-input.tag-input__text .el-input__count .el-input__count-inner {
  color: white !important;
  background-color: inherit !important;
}
</style>
